export default function useActiveTabDAppInfo(){return{result:null,refreshConnectionInfo:()=>{}};}